export const brand = {
  name: 'AXSELL',
  tagline: 'Para fotógrafos profissionais',
  headline: {
    prefix: 'Entregue o ensaio por um ',
    highlight: 'link exclusivo',
    suffix: ' e venda cada foto.'
  },
  subheadline:
    'Publique o álbum, compartilhe no WhatsApp e acompanhe as vendas. Marca d’água automática, carrinho de compras e download em alta só depois do pagamento.',
  ctaPrimary: 'Começar agora',
  ctaSecondary: 'Já tenho conta',
  linkExample: '/album/ABC123456',
  heroImage:
    'https://images.unsplash.com/photo-1554048612-b6a482bc67e5?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',
  navSignIn: 'Entrar',
  navSignUp: 'Criar conta',
  copyright: '© 2026 AXSELL'
};

export const featuresTitle = 'Tudo que o seu estúdio precisa';

export const features = [
  { icon: 'Images', title: 'Upload em lote', description: 'Envie centenas de fotos de uma vez, com compressão automática e marca d’água aplicada na hora.' },
  { icon: 'Link2', title: 'Link exclusivo do álbum', description: 'Cada ensaio publicado gera um endereço único, pronto para WhatsApp, e-mail ou cópia rápida.' },
  { icon: 'Wallet', title: 'Preço por foto, pacote ou álbum', description: 'Defina as três formas de venda e deixe o cliente montar o carrinho como preferir.' },
  { icon: 'ShieldCheck', title: 'Originais protegidos', description: 'As imagens em alta resolução ficam em armazenamento privado. Ninguém acessa sem comprar.' },
  { icon: 'Download', title: 'Download liberado após o pagamento', description: 'Somente as fotos compradas perdem a marca d’água e liberam download individual ou em lote.' },
  { icon: 'Smartphone', title: 'Funciona em qualquer tela', description: 'Painel e galeria responsivos para celular, tablet e desktop, com tema escuro elegante.' }
];

// Demo photos (using Unsplash portrait photos)
const demoPhotos = [
  'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=800&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=800&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=800&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=800&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1524250502761-1ac6f2e30d43?w=800&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=800&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1506863530036-1efeddceb993?w=800&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=800&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1541823709867-1b206113eafd?w=800&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1520975916090-3105956dac38?w=800&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=800&auto=format&fit=crop'
];

export const seedAlbums = [
  {
    code: 'ABC123456',
    title: 'Ensaio Ana & Pedro',
    client: 'Ana Silva',
    date: '2026-05-14',
    pricePerPhoto: 25,
    packagePrice: 180,
    packageCount: 10,
    albumPrice: 320,
    photos: demoPhotos.map((url, i) => ({ id: `p${i + 1}`, url, name: `IMG_${1000 + i}.jpg` })),
    sales: 6,
    revenue: 320
  },
  {
    code: 'XYZ789012',
    title: 'Casamento Marina',
    client: 'Marina Costa',
    date: '2026-06-02',
    pricePerPhoto: 30,
    packagePrice: 220,
    packageCount: 10,
    albumPrice: 480,
    photos: demoPhotos.slice(0, 8).map((url, i) => ({ id: `q${i + 1}`, url, name: `IMG_${2000 + i}.jpg` })),
    sales: 3,
    revenue: 90
  }
];

export const seedUsers = [
  {
    id: 'u1',
    name: 'Studio Aurélio',
    email: 'aurelio@studio.com',
    password: '123456',
    pixKey: 'aurelio@studio.com',
    createdAt: '2026-03-01'
  }
];

export const ADMIN_PASSWORD = 'admin123';
